module.exports = __webpack_public_path__ + "media/images/emblems/Cottens-coat_of_arms-680080348c8fc1bcc372c05b857a93d3.svg";